var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketInstructionTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 120,
    viewBox: "0 0 144 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3248_5099)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 48,
    width: 144,
    height: 72,
    rx: 12,
    fill: "#1E2625"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 48.5,
    width: 143,
    height: 71,
    rx: 11.5,
    stroke: "#E8FAF3",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 56C11.5675 56 8 59.5675 8 64C8 68.4325 11.5675 72 16 72C20.4325 72 24 68.4325 24 64C24 59.5675 20.435 56 16 56Z",
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 64C8.5 59.8437 11.8437 56.5 16 56.5C20.1588 56.5 23.5 59.8436 23.5 64C23.5 68.1563 20.1563 71.5 16 71.5C11.8437 71.5 8.5 68.1563 8.5 64Z",
    stroke: "#E8FAF3",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 56,
    width: 36,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 56.5,
    width: 35,
    height: 15,
    rx: 3.5,
    stroke: "#E8FAF3",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 56.5,
    width: 35,
    height: 15,
    rx: 3.5,
    fill: "#1A1D1F",
    stroke: "#23FFB0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 80,
    width: 128,
    height: 12,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 80.5,
    width: 127,
    height: 11,
    rx: 3.5,
    stroke: "#E8FAF3",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 100,
    width: 128,
    height: 12,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 100.5,
    width: 127,
    height: 11,
    rx: 3.5,
    stroke: "#E8FAF3",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.672 64.2715V32.2715",
    stroke: "#23FFB0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5 36.2676L116.864 33.3319C117.286 32.8033 118.093 32.8033 118.514 33.3319L120.836 36.2176",
    stroke: "#23FFB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 28C125.732 28 132 21.732 132 14C132 6.26797 125.732 0 118 0C110.268 0 104 6.26797 104 14C104 21.732 110.268 28 118 28ZM121.85 16.2166C121.85 14.1753 120.626 13.4772 118.175 13.1831C116.424 12.9504 116.077 12.485 116.077 11.6685C116.077 10.852 116.661 10.3252 117.829 10.3252C118.878 10.3252 119.462 10.6763 119.752 11.5499C119.809 11.7256 119.985 11.8397 120.16 11.8397H121.095C121.328 11.8397 121.503 11.6641 121.503 11.4314V11.3744C121.27 10.0924 120.222 9.1003 118.878 8.98178V7.5813C118.878 7.34864 118.702 7.17302 118.412 7.11599H117.539C117.306 7.11599 117.131 7.29154 117.074 7.5813V8.92468C115.322 9.15733 114.216 10.3252 114.216 11.7827C114.216 13.7055 115.384 14.465 117.833 14.7591C119.466 15.0488 119.994 15.4001 119.994 16.3352C119.994 17.2703 119.177 17.9112 118.07 17.9112C116.556 17.9112 116.029 17.2703 115.853 16.3966C115.796 16.164 115.621 16.0454 115.445 16.0454H114.453C114.22 16.0454 114.045 16.221 114.045 16.4537V16.5107C114.277 17.9683 115.212 19.0175 117.135 19.3116V20.7121C117.135 20.9448 117.311 21.1204 117.601 21.1774H118.474C118.707 21.1774 118.883 21.0019 118.939 20.7121V19.3116C120.691 19.0219 121.855 17.7971 121.855 16.221L121.85 16.2166ZM109.834 11.1425C108.139 15.6335 110.474 20.7085 115.023 22.3416V22.346C115.198 22.4645 115.374 22.6972 115.374 22.8728V23.6894C115.374 23.8035 115.374 23.8649 115.317 23.922C115.256 24.1547 115.023 24.2732 114.79 24.1547C111.519 23.101 109.012 20.5943 107.963 17.3281C106.216 11.7878 109.249 5.89629 114.79 4.14463C114.847 4.0876 114.966 4.0876 115.023 4.0876C115.256 4.14463 115.374 4.32025 115.374 4.55291V5.36947C115.374 5.66363 115.256 5.83486 115.023 5.95339C112.635 6.82698 110.708 8.69277 109.834 11.1425ZM120.677 4.37735C120.738 4.14462 120.972 4.0261 121.204 4.14463V4.14023C124.413 5.18952 126.981 7.70064 128.03 11.0239C129.778 16.5642 126.744 22.4557 121.204 24.2074C121.147 24.2645 121.028 24.2645 120.971 24.2645C120.738 24.2074 120.62 24.0317 120.62 23.7991V22.9825C120.62 22.6884 120.738 22.5172 120.971 22.3987C123.359 21.525 125.287 19.6592 126.161 17.2095C127.855 12.7185 125.52 7.64354 120.971 6.01041C120.796 5.89189 120.62 5.65923 120.62 5.42658V4.61001C120.62 4.49588 120.62 4.43438 120.677 4.37735Z",
    fill: "#EAEFF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3248_5099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketInstructionTwo);
export default __webpack_public_path__ + "static/media/MarketInstructionTwo.574781170b764395723359dab3a60c6b.svg";
export { ForwardRef as ReactComponent };